import { render, staticRenderFns } from "./TextMidiaBlock.vue?vue&type=template&id=49897b4a&scoped=true&"
import script from "./TextMidiaBlock.vue?vue&type=script&lang=js&"
export * from "./TextMidiaBlock.vue?vue&type=script&lang=js&"
import style0 from "./TextMidiaBlock.vue?vue&type=style&index=0&id=49897b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49897b4a",
  null
  
)

export default component.exports